export default "__VITE_ASSET__C27p2Lvm__"